enum VehicleStatus {
    New = 1,
    Registered = 2,
    Rejected = 3,
    Approved = 4,
    GradingCompleted = 5,
    PriceListed = 6,
    AuctionReady = 7,
    Sold = 8,
    Unsold = 9,
    Withdrawn = 10,
    DeliveryReady = 11,
    Delivered = 12
}

export default VehicleStatus;